<section class="section-pd bg-light-purple card-carousel gc-card-carousel">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center mb-0">
                    <h2>多國語言文法檢查工具</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-70">使用這款全能文法檢查工具，輕鬆提升多國語言寫作力！立即獲得以下語言的專業校正：</p>
                </div>
            </div>
            <div class="col-lg-8 col-md-10">
                <div id="improve-gc-check-carousel" class="carousel slide" data-ride="carousel">
                    <!-- Indicators/dots -->
                    <div class="carousel-indicators">
                        <button type="button" data-target="#improve-gc-check-carousel" data-slide-to="0" class="active">
                            英文
                        </button>
                        <button type="button" data-target="#improve-gc-check-carousel" data-slide-to="1" class="betaTag">
                            西班牙文
                        </button>
                    </div>
                    <!-- The slideshow/carousel -->
                    <div class="ct-card position-relative">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <div class="carousel-card ">
                                    <img src="/assets/images/grammar-checker/english-grammar-checker.webp" width="1538" height="824" class="img-fluid" alt="english grammar checker" />
                                    <!-- <h4>English</h4>
                                    <p>One of the reasons is <span class="wrongText">because</span> <span class="rightText">that</span> the fabrication cost <span class="wrongText">for</span> <span class="rightText">of</span> steel members depends upon the material.</p> -->
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card">
                                    <img src="/assets/images/grammar-checker/spanish-grammar-checker.webp" width="1538" height="824" class="img-fluid" alt="spanish grammar checker" />
                                    <!-- <h4>Spanish</h4>
                                    <p>Una de las razones es <span class="wrongText">porque</span> <span class="rightText">que</span> el costo de fabricación <span class="wrongText">para</span> <span class="rightText">de</span> los miembros de acero depende del material.</p> -->
                                </div>
                            </div>
                        </div>
                        <!-- Left and right controls/icons -->
                        <button class="carousel-control-prev" type="button" data-target="#improve-gc-check-carousel" data-slide="prev" aria-label="Previous Slide">
                            <span class="carousel-control-prev-icon"></span>
                        </button>
                        <button class="carousel-control-next" type="button" data-target="#improve-gc-check-carousel" data-slide="next" aria-label="Next Slide">
                            <span class="carousel-control-next-icon"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>